import React from "react";
import { ArrowRight, CalendarCheck } from "lucide-react";
import { Button } from "./ui/button";
import { hero, whatsappLink } from "../mock";

const Hero = () => {
  return (
    <section id="inicio" className="hero-grad relative overflow-hidden pt-32 pb-20 md:pt-40 md:pb-28">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#94a7b8]/20 blur-3xl" />
      <div className="absolute bottom-0 -left-20 w-80 h-80 rounded-full bg-[#b89a5a]/10 blur-3xl" />

      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 items-center relative">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-[#b89a5a] bg-[#b89a5a]/10 px-4 py-2 rounded-full">
            {hero.eyebrow}
          </span>
          <h1 className="font-display font-bold text-4xl md:text-6xl leading-[1.08] text-[#2f3a45] mt-6">
            {hero.title}
          </h1>
          <p className="text-[#4a5a68] text-lg mt-6 max-w-xl leading-relaxed">
            {hero.subtitle}
          </p>

          <div className="flex flex-wrap gap-4 mt-9">
            <Button
              asChild
              size="lg"
              className="bg-[#b89a5a] hover:bg-[#a5884b] text-white rounded-full px-8 h-13 py-6 text-base shadow-lg hover:shadow-xl transition-all"
            >
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                <CalendarCheck className="w-5 h-5 mr-2" /> Agendar Consulta
              </a>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="rounded-full px-8 py-6 text-base border-[#2f3a45] text-[#2f3a45] hover:bg-[#2f3a45] hover:text-white transition-all"
            >
              <a href="#tratamentos">
                Conheça os tratamentos <ArrowRight className="w-5 h-5 ml-2" />
              </a>
            </Button>
          </div>

          <div className="grid grid-cols-3 gap-6 mt-12 max-w-lg">
            {hero.stats.map((s) => (
              <div key={s.label}>
                <div className="font-display font-bold text-3xl text-[#2f3a45]">{s.value}</div>
                <div className="text-sm text-[#6b7a88] mt-1 leading-tight">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-4 bg-[#94a7b8]/20 rounded-[2rem] rotate-3" />
          <img
            src={hero.image}
            alt="Exame oftalmológico na Foco Vision"
            className="relative rounded-[2rem] shadow-2xl w-full h-[420px] md:h-[520px] object-cover"
          />
          <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl px-6 py-4 flex items-center gap-4">
            <div className="w-11 h-11 rounded-full bg-[#b89a5a]/15 flex items-center justify-center">
              <CalendarCheck className="w-6 h-6 text-[#b89a5a]" />
            </div>
            <div>
              <div className="font-display font-semibold text-[#2f3a45]">Atendimento humanizado</div>
              <div className="text-sm text-[#6b7a88]">Particular e reembolso</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
